import type { BHTranslationDictionary } from '@adornis/buchungsheld-db/translations/translation.js';
import '@adornis/buchungsheld-theme/components/tr-button-small.js';
import '@adornis/buchungsheld-theme/components/tr-icon.js';
import '@adornis/buchungsheld-theme/components/tr-tooltip.js';
import '@adornis/buchungsheld-theme/components/tr-vr.js';
import '@adornis/buchungsheld-theme/fonts/fonts.js';
import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { acss } from '@adornis/chemistry/directives/acss.js';
import { css } from '@adornis/chemistry/directives/css.js';
import { goTo } from '@adornis/router/client/open-href.js';
import { TranslationController } from '@adornis/translation-core/client/translation-controller.js';
import { html } from 'lit';
import { customElement, state } from 'lit/decorators.js';

/*
 * @element matching-hautnah-page-banner
 */
@customElement('matching-hautnah-page-banner')
export class MatchingPageAdmin extends ChemistryLitElement {
  @state() readonly _translation = new TranslationController<BHTranslationDictionary>(this);

  override render() {
    return html`
      <tr-flex space="md" padding="md">
        <tr-basic-card
          horizontal
          space="md"
          space-between
          padding="sm"
          flex
          @click=${() => goTo('/timeframes')}
          ${acss({
            color: this.colors.tone.error.shade(50),
            background: this.colors.tone.error,
            border: `1px solid ${this.colors.tone.error}`,
            cursor: 'pointer',
            userSelect: 'none',

            '&:hover': {
              background: this.colors.tone.error.shade(50),
              color: this.colors.tone.error.shade(600),
              borderColor: this.colors.tone.error.shade(600),
            },
          })}
        >
          <tr-flex horizontal space="md" flex crossaxis-center>
            <tr-icon size="xl" ${css({ fontVariationSettings: 'normal' })}>report</tr-icon>
            <tr-text bold ${css({ paddingTop: '2px' })}>
              ${this._translation.translate('timeframe', 'expiredUserDataBanner', 'title')}
            </tr-text>
            <tr-vr ${css({ background: this.colors.tone.error.shade(200) })}></tr-vr>
            <tr-text ${css({ paddingTop: '2px' })}>
              ${this._translation.translate('timeframe', 'expiredUserDataBanner', 'instruction')}
            </tr-text>
          </tr-flex>

          <tr-flex center crossaxis-center>
            <tr-basic-card
              padding="xs"
              center
              crossaxis-center
              ${acss({
                color: this.colors.tone.error.shade(50),
                background: this.colors.tone.error,
                borderColor: this.colors.tone.error.shade(50),
              })}
            >
              <tr-icon> chevron_right </tr-icon>
            </tr-basic-card>
          </tr-flex>
        </tr-basic-card>
        <tr-tooltip
          .text=${'Alle Mentor/Mentee bezogene Daten löschen - DSGVO konform'}
          placement="bottom"
        ></tr-tooltip>

        <tr-hr></tr-hr>
      </tr-flex>
    `;
  }
}
